'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    hasError: {},
    help: {},
    success: undefined,
    message: undefined,
    status: undefined
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.POST_TOKEN_AND_CART) {

        return ObjectAssign({}, state, {
            loading : true,
            hydrated : false
        });

    }

    if (action.type === Constants.POST_TOKEN_AND_CART_RESPONSE) {

        const response = action.response;
        const hasError = {};
        const help = {};
        if ( action.err) {
            let message = 'Error';
            if (action.response){
                message = action.response.message;
            }

            if ( response.statusCode === 422 && response.details && response.details.invalidZip) {
                hasError['postalCode'] = { message: 'invalid' };
            }

            return ObjectAssign({}, state, {
                loading: false,
                hasError,
                help,
                hydrated: true,
                message
            });
        }

        if ( !response.success ) {
            return ObjectAssign({}, state, {
                error: true,
                loading: false,
                hydrated: true,
                success: false,
                hasError,
                help,
                message: response.message,
                status: response.status
            });
        }

        return ObjectAssign({}, state, {
            error : undefined,
            loading: false,
            success: true,
            hasError,
            help,
            message: 'Purchase Complete',
            status: response.status
        });
    }

    return state;
};


export default reducer;
